<template>
  <div>
    <vx-card>
      <vs-table pagination :max-items="10" search :data="_prosecutions">
        <template slot="header">
          <div class="case-status-filter">
            <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.caseStatus') }}</label>
            <v-select
              v-model="filter.caseStatus"
              :clearable="true"
              :options="caseStatusFilterOptions"
              :reduce="res => res.value"
              placeholder="ทั้งหมด"
            />
          </div>
        </template>
        <template slot="thead">
          <vs-th sort-key="caseNumber">{{ $t('sections.prosecution.dataForm.caseNumber') }}</vs-th>
          <vs-th sort-key="statusDate">{{ $t('sections.prosecution.dataForm.statusDate') }}</vs-th>
          <vs-th sort-key="prosecutionType">{{ $t('sections.prosecution.dataForm.prosecutionType') }}</vs-th>
          <vs-th sort-key="contractName">{{ $t('sections.prosecution.dataForm.contractName') }}</vs-th>
          <vs-th sort-key="contractNo">{{ $t('sections.prosecution.dataForm.contractNo') }}</vs-th>
          <vs-th sort-key="total">{{ $t('sections.prosecution.dataForm.totalAsset') }}</vs-th>
          <vs-th sort-key="totalExpenseAmount">{{ $t('sections.prosecution.dataForm.totalExpense') }}</vs-th>
          <vs-th sort-key="totalAfter">{{ $t('sections.prosecution.dataForm.totalAfter') }}</vs-th>
          <vs-th sort-key="caseStatus">สถานะ</vs-th>
          <vs-th sort-key="" class="w-1/12"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="row" :key="index" v-for="(row, index) in data">
            <vs-td :data="row.caseNumber">
              {{ row.caseNumber }}
            </vs-td>
            <vs-td :data="row.date">
              {{ row.date | convYYYYMMDDToDDMMYYYY }}
            </vs-td>
            <vs-td :data="row.prosecutionTypeName">
              {{ row.prosecutionTypeName }}
            </vs-td>
            <vs-td :data="row.contractName">
              {{ row.contractName }}
            </vs-td>
            <vs-td :data="row.contractNo">
              {{ row.contractNo }}
            </vs-td>
            <vs-td :data="row.total">
              {{ row.total | numberFormat }}
            </vs-td>
            <vs-td :data="row.totalExpenseAmount">
              {{ row.totalExpenseAmount | numberFormat }}
            </vs-td>
            <vs-td :data="row.totalAfter">
              {{ row.totalAfter | numberFormat }}
            </vs-td>
            <vs-td :data="row.caseStatusName">
              <vs-chip :color="row.caseStatus | caseStatusColor" class="product-order-status">{{ row.caseStatusName  }}</vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <vx-tooltip text="ดูข้อมูลการดำเนินคดี">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-menu" @click="transaction(row)"  v-if="visibilityView(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ฝ่ายกฎหมายตีกลับข้อมูล">
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-x-circle" @click="onPressedActiveLawyerRejectModal(row)"  v-if="visibilityLawyerReject(row)"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup
      :active.sync="rejectModal.active"
      title="ฝ่ายกฎหมายตีกลับข้อมูล"
      class="custom-popup"
    >
      <div class="popup-content">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <p>เลขที่: {{  rejectModal.caseNumber }}</p>
          </div>
          <div class="vx-col w-1/2">
            <p>ชื่อสัญญา: {{  rejectModal.contractName }}</p>
          </div>
        </div>
        <div class="vx-row mt-1">
          <div class="vx-col w-full">
            <vs-textarea type="text" class="w-full" v-model="rejectModal.remark"  rows="5"/>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedLawyerReject" class="mr-1">บันทึก</vs-button>
        <vs-button color="danger" @click="onPressedUnActiveLawyerRejectModal">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import vSelect from 'vue-select'
import {ICaseStatus} from "@/constants/interface";
const {mapActions: mapProsecutionActions, mapState: mapProsecutionState } = createNamespacedHelpers('Prosecution')
const CASE_STATUS_FILTER_STORAGE_KEY = 'prosecutionCloseCancelHoldCaseStatusFilter'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      rejectModal: {
        active: false,
        id: null,
        contractName: "",
        caseNumber: "",
        remark: "",
      },
      filter: {
        caseStatus: localStorage.getItem(CASE_STATUS_FILTER_STORAGE_KEY) || null,
      },
    };
  },
  async created () {
    const vm = this
    await vm.reloadComponent(vm.$route.params);
  },
  computed: {
    ...mapProsecutionState(['prosecutions', 'status']),
    currentUser () {
      if(!this.$store.state.currentUser){
        return null
      }
      return {
        id: this.$store.state.currentUser.id,
        email: this.$store.state.currentUser.email,
        role: this.$store.state.currentUser.role
      }
    },
    isRoot(){
      if(!this.currentUser){
        return false
      }
      const { isRoot } = this.currentUser.role
      return isRoot
    },
    isLawyer(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'lawyer'
    },
    isLegalCounsel(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'legalCounsel'
    },
    isUser(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === ('normal' || 'super')
    },
    caseStatusFilterOptions(){
      const options = this.prosecutions.reduce((acc, prosecution) => {
        if (prosecution.caseStatus && !acc.find(res => res.value === prosecution.caseStatus)) {
          acc.push({
            label: prosecution.caseStatus === ICaseStatus.holdCase
              ? this.$t('getters.caseStatusOptions')[ICaseStatus.holdCase]
              : prosecution.caseStatusName,
            value: prosecution.caseStatus,
          })
        }
        return acc
      }, [])

      return options.sort((a, b) => a.label.localeCompare(b.label, 'th'))
    },
    _prosecutions(){
      const vm = this;
      return vm.prosecutions
        .filter(prosecution => !vm.filter.caseStatus || prosecution.caseStatus === vm.filter.caseStatus)
        .map(prosecution => {
        return {
          ...prosecution,
          lawyerAcceptedDate: prosecution.lawyerAcceptedDate,
          caseStatusName: prosecution.caseStatusName,
          createdAt: prosecution.createdAt,
        }
      }).sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })
    }
  },
  methods: {
    ...mapProsecutionActions(['getProsecutionsCloseCancelHold', 'updateProsecutionCaseStatus']),
    transaction(row){
      const {contract, id: prosecutionId} = row
      const { id: contractId} = contract
      this.$router.push({name: 'prosecution-transaction-detail', params: {contractId, prosecutionId}})
    },
    onPressedLawyerReject(){
      const vm = this;
      this.rejectModal.active = false;
      const { updateProsecutionCaseStatus } = vm;
      const { dialog } = vm.$vs;
      const {
        id,
        remark
      } = vm.rejectModal;
      dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการตีกลับข้อมูล',
        text: 'คุณต้องการตีกลับข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await updateProsecutionCaseStatus({
            vm,
            id: id,
            form: {
              caseStatus: ICaseStatus.draft,
              remark
            },
          })
          await vm.reloadComponent(vm.$route.params);
        }
      })
    },
    async onPressedActiveLawyerRejectModal({id, contractName, caseNumber}) {
      this.rejectModal = {
        active: true,
        id,
        contractName,
        caseNumber,
        remark: "",
      }
    },
    async onPressedUnActiveLawyerRejectModal() {
      this.rejectModal = {
        active: false,
        id: null,
        contractName: "",
        caseNumber: "",
        remark: "",
      }
    },
    visibilityView(row){
      return row;
    },
    visibilityLawyerReject({caseStatus, lawyerEmail}){
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      const caseStatuses = [ICaseStatus.draft, ICaseStatus.cancelCase, ICaseStatus.closeCase, ICaseStatus.holdCase];
      return !caseStatuses.includes(caseStatus) && (this.isRoot || isLawyerAssign);
    },
    async reloadComponent({ action = null }) {
      await this.getProsecutionsCloseCancelHold({ action });
    },
    syncCaseStatusFilterToLocalStorage(caseStatus) {
      if (caseStatus) {
        localStorage.setItem(CASE_STATUS_FILTER_STORAGE_KEY, caseStatus)
      } else {
        localStorage.removeItem(CASE_STATUS_FILTER_STORAGE_KEY)
      }
    }
  },
  watch: {
    'filter.caseStatus': {
      handler(caseStatus) {
        this.syncCaseStatusFilterToLocalStorage(caseStatus)
      },
    },
    status: {
      handler(res){
        if(res.processing !== null){
          if(res.processing){
            this.$vs.loading();
          }else{
            this.$vs.loading.close();
          }
        }
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    '$route.params': {
      handler(newParams = {}, oldParams = {}) { // ตั้งค่า default เป็น empty object
        if (newParams.action !== oldParams.action) {
          this.reloadComponent(newParams);
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.case-status-filter {
  min-width: 180px;
}
</style>
